export default __webpack_public_path__ + "static/media/BrainBreak cards16.d7fcb50a.png";